module.exports = __webpack_public_path__ + "static/media/create_rfq_right_img.d5f07b42.png";